import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=051cefaf&scoped=true&"
import script from "./Highlights.vue?vue&type=script&lang=js&"
export * from "./Highlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051cefaf",
  null
  
)

export default component.exports